import { ComponentProps, FC } from 'react';

import { Icon } from './Icon';

export const IconCircleCheckOuterBorder: FC<ComponentProps<typeof Icon>> = (props) => (
  <Icon {...props} viewBox="0 0 34 35">
    <g filter="url(#filter0_dd_43499_103221)">
      <rect x="1" y="1" width="32" height="32" rx="16" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 29C23.6274 29 29 23.6274 29 17C29 10.3726 23.6274 5 17 5C10.3726 5 5 10.3726 5 17C5 23.6274 10.3726 29 17 29ZM15.5896 21.5406L23.4635 12.9509L22.284 11.8697L14.9747 19.8435L11.6665 16.5353L10.5352 17.6667L14.4342 21.5657C14.5885 21.72 14.7991 21.8046 15.0172 21.7998C15.2354 21.7951 15.4421 21.7014 15.5896 21.5406Z"
        fill="#37967A"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_43499_103221"
        x="0"
        y="0"
        width="34"
        height="35"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_43499_103221" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_43499_103221" result="effect2_dropShadow_43499_103221" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_43499_103221" result="shape" />
      </filter>
    </defs>
  </Icon>
);
